import { connect } from 'react-redux';
import { match } from 'react-router';

import { FORM_ERROR } from 'final-form';
import { Dispatch } from 'redux';

import { FETCH_ERROR } from '@nord/tool.redux-api/es/actionTypes';

import fetchErrorFromResponse from '../../../tools/fetchErrorFromResponse';
import { IReduxAction } from '../../../types';
import { IResetPasswordValues } from '../../components/organisms/ResetPasswordForm';
import ResetPassword from '../../components/templates/ResetPassword';

interface IResetPasswordParams {
  code: string;
}

interface IResetPasswordOwnProps {
  match: match<IResetPasswordParams>;
  submitAction: (token: string, password: string) => IReduxAction;
}

const mapDispatchToProps = (
  dispatch: Dispatch,
  {
    match: {
      params: { code },
    },
    submitAction,
  }: IResetPasswordOwnProps
) => ({
  onSubmit: async ({ password }: IResetPasswordValues) => {
    const { type, payload: { errorResponse = null } = {} } = await dispatch(
      submitAction(code, password)
    );

    return type === FETCH_ERROR
      ? {
          [FORM_ERROR]: fetchErrorFromResponse(errorResponse),
        }
      : true;
  },
});

export default connect(null, mapDispatchToProps)(ResetPassword);
